/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import qs from 'query-string';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { startApplicationLoading, stopApplicationLoading } from '../../../redux/features/application/application.slice';
import { RoutePath } from '../../../shared/enums/RoutePath';
import { handleRedirectAndReload } from '../../../shared/utils/routingUtils';

export const useSwitchAccount = () => {
  const dispatch = useDispatch();
  const searchParams = qs.parse(window.location.search, { parseBooleans: true });

  useEffect(() => {
    // if user accepts an invitation, a 'shouldRefreshToken' search parameter is sent
    // the app needs to refresh in order to receive and parse the new access token
    // setting 'window.location.href' automatically refreshes the page
    if (searchParams.shouldRefreshToken === true) {
      dispatch(startApplicationLoading());
      handleRedirectAndReload(RoutePath.generateRoutePath(RoutePath.SWITCH_ACCOUNT, {}));
    }

    dispatch(stopApplicationLoading());
  }, []);

  return {
    shouldRefreshToken: searchParams.shouldRefreshToken,
  };
};
